export default __webpack_public_path__ + "static/media/Gallery-22.1b778394.jpeg";